import styled from "styled-components"
import { MEDIA_QUERIES } from "@constants"

export const InterviewBuilderStartPanelsDIV = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column-reverse;

  ${MEDIA_QUERIES.M} {
    flex-direction: row;
  }
   /* Panel */
  > div {
    display: grid;
    grid-template-rows: 120px 1fr 1fr 1fr;
    grid-template-columns: minmax(auto, 400px);
    grid-gap: 20px;
    justify-items: center;
    text-align: center;
    margin: 0 auto;
    padding: var(--spacing--S) 0 var(--spacing--L);

    .gatsby-image-wrapper {
      img {object-fit: contain !important;}
    }

    h3 { 
      margin: 0; 
      font-size: var(--font-size--2XL);
      font-weight: var(--font-weight--semibold);
    }

    p {
      margin-bottom: 0 0 20px;
    }

    select {
      width: 75%;
    }

    /* Border between panels */
    ${MEDIA_QUERIES.M} {
      &:first-of-type {
        &::after {
          content: "";
          width: 1px;
          height: calc(100% - var(--spacing--S) - var(--spacing--L));
          background: var(--color--clay-300);
          position: absolute;
          right: 50%;
          top: var(--spacing--S);
        }
      }
    }
   }
`